import { css } from "@/domains/emotion";

export const SHARED_ANIMATION_DIV_STYLES = css({
  height: "100%",
  width: "100%",
});
